import React, { Fragment } from 'react'; 
import Header from "../common/header";
import Footer from "../common/footer";
import HomeBanner from "./home-banner";
import HomeAbout from "./home-about";
import HomeProjects from "./home-projects";
import HomeLiving from "./home-living";
import HomeCommunity from "./home-community";
import HomePressRelease from "./home-press-release";
import HomeConstruction from "./home-construction";
import HomeParallax from "./home-parllax";
function HomePage() {
  
  return (
    <Fragment> 
    <Header />

    <HomeBanner />
    <HomeAbout /> 
    <HomeProjects />
    <HomeLiving /> 
    <HomeCommunity />
    <HomePressRelease />
    <HomeConstruction />
    <HomeParallax />
    <Footer /> 

</Fragment> 
  );
}

export default HomePage;